/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:00:58 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2022-07-21 16:06:09
 */
// 直播相关
let liveInfo = {
  namespaced: 'docInfo',
  state: {
    docs: undefined,
    page: 1,
    scale: 1,
    showBottom: true,
    docRight: 10,
    isFirstShow: false
  },
  getters: {
    scaleText(state) {
      return Math.ceil((state.scale * 100).toFixed(2))
    }
  },
  mutations: {
    SET_DOCS(state, data) {
      state.docs = data
    },
    SET_PAGE(state, data) {
      state.page = data
    },
    SET_SCALE(state, data) {
      state.scale = data;
    },
    SET_SHOW_BOTTOM(state, data) {
      state.showBottom = data
    },
    SET_DOC_RIGHT(state, pos) {
      state.docRight = -pos
    },
    SET_DOC_FIRST_TOOL_SHOW(state, boo) {
      state.isFirstShow = boo
    }
  }
}
export default liveInfo;